/**
 * Referenzen-Parallax:
 * Bewegt die komplette .referenz--item Karte beim Scrollen.
 * Versetzte Karten (jede 2.) driften nach oben, die anderen nach unten.
 */
function initReferenzenParrallax() {
	const cards = Array.from(document.querySelectorAll('.referenzen--grid .referenz--item'));

	if (!cards.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		cards.forEach((node) => {
			node.style.transform = '';
		});
		return;
	}

	const items = cards
		.map((node) => {
			if (!node.parentElement) {
				return null;
			}
			const siblings = Array.from(node.parentElement.children).filter((child) =>
				child.classList.contains('referenz--item')
			);
			const index = siblings.indexOf(node);
			if (index < 0) {
				return null;
			}
			const isEven = (index + 1) % 2 === 0;
			return {
				node,
				isEven,
				currentY: 0,
				targetY: 0,
				baseProgress: 0,
			};
		})
		.filter(Boolean);

	if (!items.length) {
		return;
	}

	items.forEach((entry) => {
		entry.node.style.willChange = 'transform';
	});

	const mdQuery = window.matchMedia('(min-width: 768px)');
	const oddMax = 60;
	const evenMax = 60;
	const lerp = 0.5;

	const getProgress = (rect, viewportHeight) => {
		const raw = (viewportHeight - rect.top) / (viewportHeight + rect.height);
		return Math.max(0, Math.min(1, raw));
	};

	const calibrateBaseline = () => {
		const viewportHeight = window.innerHeight || 1;
		items.forEach((entry) => {
			const rect = entry.node.getBoundingClientRect();
			entry.baseProgress = getProgress(rect, viewportHeight);
			entry.currentY = 0;
			entry.targetY = 0;
			entry.node.style.transform = 'translate3d(0, 0px, 0)';
		});
	};

	const measureTargets = () => {
		if (!mdQuery.matches) {
			items.forEach((entry) => {
				entry.targetY = 0;
			});
			return;
		}

		const viewportHeight = window.innerHeight || 1;
		items.forEach((entry) => {
			const rect = entry.node.getBoundingClientRect();
			const max = entry.isEven ? evenMax : oddMax;

			// Monotone Progress-Kurve:
			// - Beim Runterscrollen wächst progress 0 -> 1
			// - Beim Hochscrollen fällt progress 1 -> 0
			// Dadurch bleibt die Bewegungsrichtung konstant und springt nicht.
			const progress = getProgress(rect, viewportHeight);
			const delta = progress - entry.baseProgress;
			const drift = delta * max;

			// Gerade/versetzte Karten nach oben, ungerade nach unten.
			entry.targetY = entry.isEven ? -drift : drift;
		});
	};

	let running = true;
	const animate = () => {
		if (!running) {
			return;
		}
		items.forEach((entry) => {
			entry.currentY += (entry.targetY - entry.currentY) * lerp;
			entry.node.style.transform = `translate3d(0, ${entry.currentY.toFixed(2)}px, 0)`;
		});
		window.requestAnimationFrame(animate);
	};

	const onScroll = () => {
		measureTargets();
	};

	const onResize = () => {
		calibrateBaseline();
		measureTargets();
	};

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);
	mdQuery.addEventListener('change', onResize);
	calibrateBaseline();
	measureTargets();
	window.requestAnimationFrame(animate);
}

/**
 * Parallax für Cover-Wide-Images:
 * Das innere Bild bewegt sich innerhalb von .wide--image--wrap beim Scrollen nach oben
 * und beim Hochscrollen wieder nach unten (zur Baseline zurück).
 */
function initWideImageParrallax() {
	const items = Array.from(document.querySelectorAll('.wide--image--wrap'))
		.map((wrap) => {
			const image = wrap.querySelector('img');
			if (!image) {
				return null;
			}
			return {
				wrap,
				image,
				currentY: 0,
				targetY: 0,
				startScroll: 0,
				range: 1,
			};
		})
		.filter(Boolean);

	if (!items.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		items.forEach((entry) => {
			entry.image.style.transform = '';
		});
		return;
	}

	const maxShift = 84;
	const positionLerp = 0.28;

	const getProgress = (value, start, range) => {
		const raw = (value - start) / range;
		return Math.max(0, Math.min(1, raw));
	};

	const calibrateLayout = () => {
		const viewportHeight = window.innerHeight || 1;
		const pageY = window.scrollY || window.pageYOffset || 0;
		items.forEach((entry) => {
			const rect = entry.wrap.getBoundingClientRect();
			const wrapTopAbs = rect.top + pageY;
			entry.startScroll = wrapTopAbs - viewportHeight;
			entry.range = viewportHeight + rect.height;
			entry.currentY = 0;
			entry.targetY = 0;
			entry.image.style.willChange = 'transform';
			entry.image.style.backfaceVisibility = 'hidden';
			entry.image.style.transform = 'translate3d(0, 0px, 0)';
		});
	};

	const measureTargets = (scrollY) => {
		items.forEach((entry) => {
			const progress = getProgress(scrollY, entry.startScroll, entry.range);
			// Runterscrollen -> Bild nach oben; Hochscrollen -> zurück nach unten.
			entry.targetY = -(progress * maxShift);
		});
	};

	const render = () => {
		const scrollY = window.scrollY || window.pageYOffset || 0;
		measureTargets(scrollY);

		items.forEach((entry) => {
			entry.currentY += (entry.targetY - entry.currentY) * positionLerp;
			entry.image.style.transform = `translate3d(0, ${entry.currentY}px, 0)`;
		});

		window.requestAnimationFrame(render);
	};

	const onResize = () => {
		calibrateLayout();
		const scrollY = window.scrollY || window.pageYOffset || 0;
		measureTargets(scrollY);
	};

	window.addEventListener('resize', onResize);
	calibrateLayout();
	window.requestAnimationFrame(render);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initReferenzenParrallax();
		initWideImageParrallax();
	});
} else {
	initReferenzenParrallax();
	initWideImageParrallax();
}

